import React from "react";
import {
  useStepData
} from "components/StepForm";
import { cs } from "utils/classnames";
import { RadioButton } from 'primereact/radiobutton';

export function Step3() {
  const [shouldSchedulePickup, setShouldSchedulePickup] = useStepData<boolean>(
    "shouldSchedulePickup",
    false
  );

  return (
    <div className="onboarding-steps">
      <h1 className="onboarding-step--title">Step 3</h1>
      <div className="onboarding-donate">
        <h4>How do you want to send us your items? (Select One) </h4>
        <div className={cs('px-3 py-1 cursor-pointer', { 'bg-green-200': !shouldSchedulePickup })} onClick={() => setShouldSchedulePickup(false)}>
          <p>
            <div className='mb-2'>
              <strong><input type='radio' checked={!shouldSchedulePickup} /> Self-Drop</strong>
            </div>
            Please note that our sellers need to pay Rs.50/kg while dropping their packages in our Self-Drop locations.
          </p>
        </div>
        <div className={cs('px-3 py-1 cursor-pointer', { 'bg-green-200': shouldSchedulePickup })} onClick={() => setShouldSchedulePickup(true)}>
          <p>
            <div className='mb-2'>
              <strong><input type='radio' checked={shouldSchedulePickup} /> Home Pickup</strong>
            </div>
            Pickup fee ranges from Rs.150 – Rs.480 (depending on the location). Also, items weighing up to 15kg only can be picked up at a time.
          </p>
        </div>
      </div>
    </div>
  );
}
